var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('handbook-list',{attrs:{"title":"杂草手册","kindLabel":"杂草","api":_vm.api}})}
var staticRenderFns = []

export { render, staticRenderFns }